import {Component, EventEmitter, Output} from "@angular/core";
import {Money} from "money";
import {CartItem} from "purchasing/cart/cart-item";
import {BehaviorSubject} from "rxjs";
import {fgURL} from "site";

@Component({
	selector: "keep-shopping-modal",
	template: `
		<modal *ngIf="showModal" (close)="close()">
			<header class="modal_header">
				<h2>Continue Shopping?</h2>
			</header>
			<div class="modal_body">
				<p>Added {{(cartItems| async)?.length}} items totalling <b>{{subtotal | async | money}}</b></p>
			</div>
			<footer class="modal_footer">
				<div class="modal_buttons">
					<button class="button-link" (click)="close()">Keep Shopping</button>
					<button class="button" (click)="goToCart()">Proceed To Cart</button>
				</div>
			</footer>
		</modal>
	`,

})
export class KeepShoppingModalComponent {
	showModal = false;
	cartURL = `${fgURL}purchasing/cart`;
	@Output() continueShopping = new EventEmitter();
	cartItems = new BehaviorSubject<Array<CartItem>>([]);

	subtotal = this.cartItems
		.map(cartItems => {
			let prices = cartItems
				.map(i => i.price)
				.filter(p => p != null);

			return Money.sum(prices);
		})
		.publishReplay(1)
		.refCount();

	constructor() { }

	goToCart() {
		this.close();
		window.location.href = this.cartURL;
	}

	addModalItem(cartItem: CartItem) {
		this.cartItems.next(this.cartItems.value.concat(cartItem));
	}

	open() {
		this.showModal = true;
	}

	close() {
		this.showModal = false;
		this.continueShopping.emit();
	}
}
